import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import packageJson from '../../../package.json';
import Notification from '../components/Notification';
import { useLoggedInUserContextProvider } from '../../context/LoggedInUserContext';

const { version } = packageJson;

const PageTitle = ({
  motherMenu,
  activeMenu,
  notificationMessage = '',
  notificationTitle = '',
  notificationIcon = null,
  notificationIconColor = null,
  notificationAction = null,
  setFilterInstance = null,
}) => {
  const path = window.location.pathname.split('/');

  const { userDetails, setUserDetails, originalUserDetails } =
    useLoggedInUserContextProvider();

  const isMasquerading =
    originalUserDetails && userDetails?.id !== originalUserDetails?.id;

  const navigate = useNavigate();

  const restoreOriginalUser = () => {
    if (originalUserDetails) {
      navigate('/nominations');
      setUserDetails(originalUserDetails);
    }
  };

  return (
    <>
      <div className="row page-titles mx-0">
        <ol className="breadcrumb d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <li className="breadcrumb-item active">
              <Link to={`/${path[path.length - 1]}`}>{motherMenu}</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/${path[path.length - 1]}`}>{activeMenu}</Link>
            </li>
            <span>
              <i className="version-span bg-dark">Version {version}</i>
            </span>
          </div>

          {isMasquerading && (
            <button
              type="button"
              className="btn btn-success btn-sm rounded-pill d-flex align-items-center"
              onClick={restoreOriginalUser}
              title="Click to restore original user"
            >
              <span>Exit Masquerade</span>
            </button>
          )}
        </ol>
      </div>
      {notificationMessage && notificationMessage !== '' && (
        <Notification
          message={notificationMessage}
          title={notificationTitle}
          icon={notificationIcon}
          iconColor={notificationIconColor}
          action={notificationAction}
          setFilterInstance={setFilterInstance}
        />
      )}
    </>
  );
};

PageTitle.propTypes = {
  motherMenu: PropTypes.string,
  activeMenu: PropTypes.string,
  notificationMessage: PropTypes.string,
  notificationTitle: PropTypes.string,
  notificationIcon: PropTypes.string,
  notificationIconColor: PropTypes.string,
  notificationAction: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
  }),
  setFilterInstance: PropTypes.func,
};

export default PageTitle;
